<template>
  <div>
    <section>
      <!-- Title -->
      <div class="title">
        <h1>Dashboard</h1>
        <div class="clearfix"></div>
      </div>
      <!-- Main Content -->
      <div class="main-content">
        <div class="row">
          <div class="col-md-2" align="left">
            <button
              class="btn btn-filters"
              type="button"
              data-toggle="collapse"
              data-target="#collapseExample"
              aria-expanded="false"
              aria-controls="collapseExample"
            >
              <i class="fas fa-filter"></i> Filtros
            </button>
          </div>
          <div class="col-md-2">
            <button class="btn btn-filters" type="button" @click="getEntity">
              <i class="fas fa-sync-alt"></i> Atualizar
            </button>
          </div>
          <!-- <div class="col-md-8" align="right" style="margin-top: -10px; font-size: 18px">
            Tamanho da Tabela: {{ size.size }} Mb
          </div> -->
        </div>

        <div class="row collapse mb-3" id="collapseExample">
          <div class="col-md-6">
            <label>Filtrar Cliente</label>
            <v-select
              :options="clientsF"
              label="name"
              :reduce="(clientsF) => clientsF.id"
              multiple
              class="style-chooser"
              v-model="filters.client_id"
            >
              <div slot="no-options">Nenhum registro encontrado.</div>
            </v-select>
          </div>
          <div class="col-md-6">
            <label>Filtrar Aplicação</label>
            <v-select
              :options="applications"
              label="title"
              :reduce="(applications) => applications.id"
              multiple
              class="style-chooser"
              v-model="filters.application_id"
            >
              <div slot="no-options">Nenhum registro encontrado.</div>
            </v-select>
          </div>
          <div class="col-md-4 mt-2">
            <label>Status</label>
            <v-select
              :options="status"
              label="text"
              :reduce="(status) => status.id"
              multiple
              class="style-chooser"
              v-model="filters.status"
            >
              <div slot="no-options">Nenhum registro encontrado.</div>
            </v-select>
          </div>
          <div class="col-md-4 mt-2">
            <label>Data de Instalação</label>
            <input
              type="date"
              class="form-control"
              v-model="filters.created_at"
            />
          </div>
          <div class="col-md-4 mt-2">
            <label>Prazo</label>
            <input
              type="date"
              class="form-control"
              v-model="filters.end_date"
            />
          </div>
          <div class="col-md-12 mt-4 mb-3" align="center">
            <button class="btn btn-add" @click="getEntity()">Pesquisar</button>
          </div>
        </div>

        <div class="row" v-if="!isLoading">
          <div class="col-md-12">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Cliente</th>
                  <th scope="col">CNPJ</th>
                  <th scope="col">Telefone</th>
                  <th scope="col">Aplicação</th>
                  <th scope="col">Instalado em</th>
                  <th scope="col">Prazo</th>
                  <th scope="col">Status</th>
                  <th scope="col">Efetivo</th>
                  <th scope="col">Ação</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(client, index) in clients"
                  :key="client.id"
                  :class="client.expired && client.status == 1 ? 'expired' : ''"
                >
                  <td>{{ client.id }}</td>
                  <td>{{ client.client.name }}</td>
                  <td>{{ client.client.cnpj }}</td>
                  <td>{{ client.client.telephone }}</td>
                  <td>{{ client.application.title }}</td>
                  <td>{{ client.created_at }}</td>
                  <td style="cursor: pointer">
                    <div class="row">
                      <div class="col-md-12">
                        <span
                          @click="changeEndDate = index"
                          v-if="changeEndDate != index"
                          >{{ client.end_date }}</span
                        >
                      </div>
                      <div class="col-md-7">
                        <input
                          v-if="changeEndDate == index"
                          type="date"
                          class="form-control"
                          v-model="new_date"
                        />
                      </div>
                      <div class="col-md-2">
                        <button
                          v-if="changeEndDate == index"
                          class="btn btn-add"
                          @click="saveDate(client)"
                        >
                          <i class="far fa-save"></i>
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span
                      style="font-size: 14px"
                      :class="
                        client.status == 1
                          ? 'badge badge-success'
                          : client.status == 2
                          ? 'badge badge-danger'
                          : 'badge badge-dark'
                      "
                      data-toggle="tooltip"
                      data-placement="top"
                      :title="
                        client.last_user
                          ? 'Última atualização: ' + client.last_user.name
                          : ''
                      "
                    >
                      {{
                        client.status == 1
                          ? "Ativo"
                          : client.status == 2
                          ? "Inativo"
                          : "Deletado"
                      }}</span
                    >
                  </td>
                  <td>
                    <span
                      style="font-size: 14px"
                      :class="
                        client.effective == 1
                          ? 'badge badge-success'
                          : client.effective == 0
                          ? 'badge badge-danger'
                          : 'badge badge-dark'
                      "
                    >
                      {{
                        client.effective == 1
                          ? "Sim"
                          : client.effective == 0
                          ? "Não"
                          : "Deletado"
                      }}</span
                    >
                  </td>
                  <td v-if="client.status <= 2">
                    <button
                      :class="
                        client.status == 1
                          ? 'btn btn-crud delete'
                          : 'btn btn-crud edit'
                      "
                      @click="changeStatus(client)"
                    >
                      <i
                        :class="
                          client.status == 1 ? 'fas fa-times' : 'fas fa-check'
                        "
                      ></i>
                    </button>
                    <button
                      class="btn btn-crud delete"
                      @click="deleteClient(client)"
                    >
                      <i class="fas fa-trash-alt"></i>
                    </button>
                    <button
                      type="button"
                      data-toggle="tooltip"
                      data-placement="top"
                      :title="
                        client.effective
                          ? 'Inativar Cliente'
                          : 'Efetivar Cliente'
                      "
                      :class="
                        client.effective == 1
                          ? 'btn btn-crud delete'
                          : 'btn btn-crud edit'
                      "
                      @click="statusEffective(client)"
                    >
                      <i
                        :class="
                          client.effective == 1
                            ? 'fas fa-times'
                            : 'fas fa-check-circle'
                        "
                      ></i>
                    </button>
                  </td>
                  <td v-else></td>
                </tr>
                <tr>
                  <td colspan="9" align="center" v-if="clients.length == 0">
                    Nenhum registro encontrado
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          class="row justify-content-center"
          align="center"
          style="padding: 15px"
        >
          <div class="col-md-12">
            <pagination
              :records="total"
              :options="options"
              :per-page="20"
              @paginate="getEntity"
            ></pagination>
          </div>
        </div>
      </div>
    </section>

    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Pagination } from "vue-pagination-2";

export default {
  data() {
    return {
      new_date: "",
      clientsF: [],
      applications: [],
      changeEndDate: 999999,
      fullPage: true,
      isLoading: true,
      filters: {
        status: [1, 2],
      },
      clients: [],
      total: 0,
      status: [
        {
          id: 1,
          text: "Ativo",
        },
        {
          id: 2,
          text: "Inativo",
        },
        {
          id: 3,
          text: "Deletado",
        },
      ],
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
    };
  },
  computed: {},
  methods: {
    getEntity: function (page) {
      const self = this;
      const api = self.$store.state.api + "dashboards/?page=" + page;
      self.isLoading = true;

      self.$http
        .post(api, self.filters)
        .then((response) => {
          self.clients = response.data.data;
          self.total = response.data.total;
          self.isLoading = false;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    changeStatus: function (client) {
      const self = this;
      const api = self.$store.state.api + "change-status";
      self.isLoading = true;

      self.$http
        .post(api, { client: client })
        .then(() => {
          self.isLoading = false;
          self.getEntity();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    statusEffective: function (client) {
      const self = this;
      const api = self.$store.state.api + "status-effective";

      self.$http
        .post(api, { client: client })
        .then(() => {
          self.isLoading = false;
          self.getEntity();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    deleteClient: function (client) {
      const self = this;
      const api = self.$store.state.api + "delete-client";

      swal({
        title: "Deseja deletar a conta do cliente?",
        text: "Esta ação não poderá ser desfeita.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "Ação cancelada!", "info");
            break;
          case "confirm":
            self.isLoading = true;
            self.$http
              .post(api, { client: client })
              .then(() => {
                self.isLoading = false;
                self.getEntity();
              })
              .catch((error) => {
                self.isLoading = false;
                self.getEntity();
                swal("Ops :/", "Não foi possível deletar o registro!", "error");
              });
            break;
        }
      });
    },
    saveDate: function (client) {
      const self = this;
      const api = self.$store.state.api + "save-date";
      self.isLoading = true;

      self.$http
        .post(api, { client: client, date: self.new_date })
        .then(() => {
          self.isLoading = false;
          self.changeEndDate = 999999;
          self.getEntity();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getClients: function () {
      const self = this;
      const api = self.$store.state.api + "clients?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.clientsF = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getApplications: function () {
      const self = this;
      const api = self.$store.state.api + "applications?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.applications = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  components: { vSelect, Loading, Pagination },
  props: {},
  mounted: function () {
    this.getEntity();
    this.getClients();
    this.getApplications();
    setTimeout(function () {
      $(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });
    }, 2000);
  },
};
</script>
<style scoped>
/* min-width */
@media screen and (min-width: 900px) {
  .margin-home {
    margin-top: -20px;
  }
}
#Chart1 {
  height: 300px;
  max-width: 100%;
  z-index: 1;
}
.expired {
  background-color: rgb(249, 148, 148);
}
</style>


// WEBPACK FOOTER //
// src/components/Home.vue